'use client';

import {
  BulletedListRules,
  isOrderedList,
  OrderedListRules,
} from '@platejs/list';
import { ListPlugin } from '@platejs/list/react';
import { KEYS } from 'platejs';

import { FieldIndentKit } from '@/components/editor/plugins/field-indent-kit';
import { BlockList } from '@/components/ui/block-list';

/** Field-tier lists: `-` bullets and `1.` ordered (Markdown Guide basic). */
export const FieldListKit = [
  ...FieldIndentKit,
  ListPlugin.configure({
    inputRules: [
      BulletedListRules.markdown({ variant: '-' }),
      OrderedListRules.markdown({ variant: '.' }),
    ],
    inject: {
      nodeProps: {
        nodeKey: KEYS.listType,
        query: ({ nodeProps }) => {
          const element = nodeProps.element;

          return !!element?.listStyleType && !isOrderedList(element);
        },
        transformProps: ({ props }) => ({
          ...props,
          role: 'listitem',
          style: {
            ...props.style,
            display: 'list-item',
          },
        }),
      },
      targetPlugins: [
        ...KEYS.heading,
        KEYS.p,
        KEYS.blockquote,
        KEYS.img,
      ],
    },
    render: {
      belowNodes: BlockList,
    },
  }),
];
